import React from 'react';
import { Leaf } from 'lucide-react';
import { startProductTour } from '../../services/productTour';

// Simple site footer, styled to match the header (emerald leaf mark, muted
// text). Purely informational — brand, disclaimer, copyright.
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-8 border-t border-gray-200 bg-white">
      <div className="max-w-[1700px] mx-auto px-6 py-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
            <Leaf size={16} />
          </div>
          <span className="text-sm font-semibold text-gray-900">TheLeaf</span>
          <span className="hidden sm:inline text-xs text-gray-400">· quiet, data-driven investing</span>
          <button
            onClick={() => { window.scrollTo({ top: 0 }); startProductTour(); }}
            className="ml-2 text-xs text-emerald-700 hover:underline"
          >
            Take a tour
          </button>
        </div>

        <p className="text-[11px] leading-relaxed text-gray-400 sm:text-right sm:max-w-md">
          For research and education only — not financial advice. Markets carry risk;
          data may be delayed. © {year} TheLeaf.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
